<!--TODO: If possible move this into axios going forward-->
<template>
  <div>
    <button class="btn btn-sm btn-block btn-default waves-effect" @click="openFilePicker">
      <i class="zmdi zmdi-cloud-upload f-16 m-r-5" />
      {{ $t('Add file') }}
    </button>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <PickerFileFilebank
      v-slot="{ openFilePicker }"
      :default-tags="[$t('Conversations')]"
      @files-selected="addFiles"
    >
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <BaseModal
        :header-text="$t('Add files')"
        :is-open="isOpen"
        :confirm-button-text="$t('Send')"
        :disabled="selectedFiles.length === 0"
        modal-id="dialogAttachFiles"
        @save="submitForm"
        @cancel="isOpen = false"
      >
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <BaseHtmlForm
          ref="form"
          :action="'/messages/' + threadId"
          enctype="application/x-www-form-urlencoded"
          data-ignore-unsaved
          method="PUT"
          append-user-and-account
        >
          <input name="message_type" type="hidden" value="files" />

          <br />
          <h4>{{ $t('Chosen files') }}</h4>

          <span v-if="selectedFiles.length === 0" class="text-muted">
            {{ $t('No files selected.') }}
          </span>

          <div v-for="file of selectedFiles" :key="file.localId" class="clip-text nowrap p-b-5">
            <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
            <file-icon :icon="file.icon" size="sm" />

            {{ file.name }}

            <input :value="file.localId" type="hidden" name="files[]" />
          </div>

          <br />
          <br />

          <button class="btn btn-primary submit-button" type="button" @click="openFilePicker">
            {{ $t('Add files') }}
          </button>

          <br />
          <br />

          <div class="form-group">
            <textarea
              v-model="message"
              :placeholder="$t('Add a comment here...')"
              name="message"
              class="form-control"
            />
          </div>
        </BaseHtmlForm>
      </BaseModal>
    </PickerFileFilebank>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    threadId: { type: Number, default: () => null },
  },
  data() {
    return {
      isOpen: false,
      selectedFiles: [],
      message: null,
    }
  },
  computed: {
    draftMessage() {
      return this.$store.getters.draftMessage
    },
  },
  watch: {
    draftMessage(value) {
      this.updateMessage(value)
    },
  },
  methods: {
    updateMessage: debounce(function (value) {
      this.message = value
    }, 500),
    submitForm() {
      window.unsaved = false
      this.$refs.form.submit()
    },
    openFilePicker() {
      this.isOpen = true
    },
    addFiles(fileArray) {
      this.selectedFiles = fileArray
    },
  },
}
</script>

<style scoped lang="scss"></style>
